import React, {useContext, useState} from "react";
import Badge from "../../../components/Badge.jsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {LocalDateTime} from "@js-joda/core";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";
import YesNo from "../../../components/YesNo.jsx";
import {ProjectIntegrationsApi} from "../../../api/authority/generated/index";
import toast from "react-hot-toast";
import {useErrorTranslation} from "../../../api/utilities/translateErrorMessage.js";
import {GlobalContext} from "../../../utils/context/GlobalContextProvider.jsx";
import BrandLogo from "../../../utils/brands/BrandLogo.jsx";
import {useBrand} from "../../../utils/brands/branding.js";
import ActionButton from "../../../components/ActionButton.jsx";

export default function ThirdPartyServiceRow(
    {project, projectIntegration, onDeleted}
) {
    let navigate = useNavigate();
    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let {getAuthorityConfiguration} = useContext(GlobalContext);

    let brand = useBrand(projectIntegration.name);

    /*let bg = Branding[projectIntegration.name]['bg'] ?? 'bg-slate-300 dark:bg-slate-600';
    let text = Branding[projectIntegration.name]['text'] ?? 'text-slate-800 dark:text-slate-100';*/

    let status = 'emerald'; // rose, yellow
    let statusText = 'OK';

    let zeroPad = (num, places = 2) => String(num).padStart(places, '0')
    let lastRegularUpdate = projectIntegration.lastRegularUpdate
        ? LocalDateTime.parse(projectIntegration.lastRegularUpdate)
        : null;
    let lastRegularUpdateString = lastRegularUpdate
        ? `${lastRegularUpdate.dayOfMonth()}.${lastRegularUpdate.monthValue()}.${lastRegularUpdate.year()}` +
        ` ` + `${zeroPad(lastRegularUpdate.hour())}:${zeroPad(lastRegularUpdate.minute())}:${zeroPad(lastRegularUpdate.second())}`
        : t('project.no-regular-update-yet');

    status = 'slate';
    statusText = t('project.unknown-status');

    if (projectIntegration.errors.length > 0) {
        status = 'rose';
        statusText = t('project.errors-exclamation');
    }

    if (!projectIntegration.authorizationSuccessful) {
        status = 'rose';
        statusText = t('project.not-connected');
    }

    if (projectIntegration.authorizationSuccessful) {
        status = 'emerald';
        statusText = t('project.connected');
    }


    let [deleteYesNoVisible, setDeleteYesNoVisible] = useState(false);

    let askToRemoveIntegration = () => {
        setDeleteYesNoVisible(true);
    };

    let removeIntegration = () => {
        new ProjectIntegrationsApi(getAuthorityConfiguration())
            .deleteProjectIntegration({
                integrationId: projectIntegration.id,
                projectId: project.id,
            })
            .then(() => {
                navigate('/project/' + project.id + '/settings/integrations');
                onDeleted();
                toast.success(t('project.integration-removed'))
            })
            .catch((e) => et(e).then(toast.error));
    };

    return (
        <div className={
            'comp__integrationListItem ' +
            'flex gap-2 justify-between items-center p-2' + ' ' +
            'px-4 mb-3 rounded-xl bg-white border-1' + ' ' +
            'dark:border-0 dark:bg-slate-800'
        }>
            <BrandLogo brand={brand}/>
            <div className="col-name text-sm font-medium my-auto w-2/12 leading-5">
                {brand.name}
            </div>
            <div className="col-delimiter"></div>
            <div className="col-date my-auto w-3/12">
                <div
                    className="text-xs"
                    title={t('project.last-regular-update')}
                >
                    {lastRegularUpdateString}
                </div>
            </div>
            <div className="col-status my-auto w-2/12">
                <Badge color={status}>{statusText}</Badge>
            </div>
            <div className="flex gap-1 col-action my-auto w-1/12 text-right">
                {brand?.editable !== false && (
                    <ActionButton
                        icon={'pencil'}
                        onClick={() => navigate(
                            "/project/" + projectIntegration.project +
                            "/settings/integrations?integrationId=" + projectIntegration.id
                        )}
                    />
                )}
                <ActionButton
                    icon={'trash'}
                    variant={'primary-red'}
                    onClick={() => askToRemoveIntegration()}
                />
                <YesNo
                    setVisible={setDeleteYesNoVisible}
                    visible={deleteYesNoVisible}
                    question={t('project.remove-integration',)}
                    onYes={() => {
                        removeIntegration()
                    }}
                />
            </div>
        </div>
    );
}
